import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Card, CardBody, Media, Button, Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input, Table,
} from 'reactstrap'
import moment from 'moment'
import Select from '../../../components/Template/Input/Select'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import {
  getLastExpedientInput, getProjects,
  getActivities, finishExpedient,
} from '../../../store/ducks/humanResources'
import api from '../../../services/segi/index'
import oikosApi from '../../../services/oikos/index'
import qs from 'qs'

class FinishExpedient extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addActivityDialogIsOpen: false,
      newActivity: DEFAULT_NEW_ACTIVITY,
      registeredActivities: [],
      projectInputError: '',
      activityInputError: '',
      descriptionInputError: '',
      timeInputError: '',
    }
  }

  componentDidMount() {
    const { getProjects, getLastExpedientInput } = this.props

    getProjects()
    getLastExpedientInput()
  }

  strToMins = (t) => {
    const s = t.split(':')
    return Number(s[0]) * 60 + Number(s[1])
  }

  minsToStr = (t) => {
    const hours = Math.trunc(t / 60)

    if (hours > 9) {
      return `${Math.trunc(t / 60)}:${(`00${t % 60}`).slice(-2)}`
    }
    return `0${Math.trunc(t / 60)}:${(`00${t % 60}`).slice(-2)}`
  }

  toggleModal = () => {
    this.setState(prevState => ({
      addActivityDialogIsOpen: !prevState.addActivityDialogIsOpen,
    }))

    document.body.classList.add('no_padding')
  }

  handleNewActivitySubmit = (remainingTime) => {
    const { newActivity, registeredActivities } = this.state

    if (!newActivity.project) this.setState({ projectInputError: 'Campo obrigatório.' })
    if (!newActivity.activity) this.setState({ activityInputError: 'Campo obrigatório.' })
    if (!newActivity.description) this.setState({ descriptionInputError: 'Campo obrigatório.' })
    if (!newActivity.time) this.setState({ timeInputError: 'Campo obrigatório.' })
    if (
      !HOUR_MINUTE_REGEX.test(newActivity.time)
      || newActivity.time === '00:00'
      || this.strToMins(newActivity.time) > this.strToMins(remainingTime)
    ) {
      this.setState({ timeInputError: 'Valor inválido.' })
    }

    if (
      newActivity.project && newActivity.activity
      && newActivity.description && newActivity.time
      && HOUR_MINUTE_REGEX.test(newActivity.time)
      && newActivity.time !== '00:00'
      && this.strToMins(newActivity.time) <= this.strToMins(remainingTime)
    ) {
      this.setState({
        addActivityDialogIsOpen: false,
        registeredActivities: [
          ...registeredActivities,
          {
            project: newActivity.project,
            activity: newActivity.activity,
            description: newActivity.description,
            time: newActivity.time,
          },
        ],
        newActivity: DEFAULT_NEW_ACTIVITY,
      })
    }
  }

  handleSubmit = async (props) => {
    const { registeredActivities } = this.state
    const { finishExpedient } = this.props

    const projectActivities = registeredActivities.filter(activity => (
      activity
      && activity.project
      && activity.project.proj_id
    ))

    if (projectActivities.length > 0) {
      /* await Promise.all(projectActivities.map(activity => (
        this.getProductStatus(activity.project.proj_id, activity.activity)
      ))) */
    }

    const items = registeredActivities.map(activity => ({
      projeto_id: activity.project.value,
      atividade: activity.activity,
      descricao: activity.description,
      tempo: activity.time,
    }))

    const data = {
      Data: props.exitDate,
      DataEntrada: `${props.exitDate} ${props.inputTime}`,
      DataSaida: `${props.exitDate} ${props.exitTime}`,
      retroativo: props.retroativo,
      Justificativa: props.justificativa,
      items,
    }

    finishExpedient(data)
  }

  listProducts = async (proj_id) => {
    const formData = new FormData()
    formData.append('acao', 'lista_produtos')
    formData.append('projeto_id', `${proj_id}`)

    const res = await api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.log(res)
  }

  getProductStatus = async (proj_id, prod_desc) => {
    const resProduto = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prod',
      data: {
        proj_id: proj_id,
        prod_desc: prod_desc,
        prod_ativo: 1
      }
    })}`)

    console.log(resProduto)

    const resStatus = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prodStatusAlt',
      data: {
        prod_id: resProduto.data[0].prod_id,
        prodStatusAlt_ativo: 1,
      },
    })}`)

    console.log(resStatus.data)

    if (resStatus.data.length > 0) {
      if (!resStatus.data.filter(status => status.prodStatusTp_id > 1).length > 0) {
        await oikosApi.post('/', {
          table: 'prodStatusAlt',
          action: 'insert',
          data: {
            prod_id: resProduto.data[0].prod_id,
            prodStatusTp_id: 2,
            prodStatusAlt_data: moment().format('YYYY-MM-DD'),
            prodStatusAlt_obs: 'Iniciando produto ao registrar atividade no encerramento de expediente',
            prodStatusAlt_usuarioCria: this.props.auth.user.pf_id,
            prodStatusAlt_usuarioMod: this.props.auth.user.pf_id,
          },
        })
      }
    }


  }

  render() {
    const { getActivities } = this.props
    const {
      addActivityDialogIsOpen,
      newActivity, registeredActivities,
      projectInputError, activityInputError,
      descriptionInputError, timeInputError,
    } = this.state
    const {
      lastExpedientInput, getProjectsIsLoading,
      projects, activities, getActivitiesIsLoading, finishExpedientIsLoading,
    } = this.props.humanResources

    if (!this.props.location.props || !this.props.location.props.exitTime) {
      return (
        <Redirect to="/" />
      )
    }

    if (this.props.location.props.exitTime) {
      const exitTimeParsed = this.props.location.props.DataSaida || moment(this.props.location.props.exitTime).format('LT')
      const exitDate = moment(this.props.location.props.exitTime).format('YYYY-MM-DD')
      const totalTime = this.minsToStr(
        this.strToMins(exitTimeParsed)
        - this.strToMins(this.props.location.props.DataEntrada || lastExpedientInput),
      )
      const registeredTime = () => {
        let time = 0
        if (registeredActivities && registeredActivities.length > 0) {
          registeredActivities.map(activity => time += this.strToMins(activity.time))
        }
        return time
      }
      const remainingTime = () => this.minsToStr(this.strToMins(totalTime) - registeredTime())

      return (
        <div className="page-content">
          <Modal
            centered
            isOpen={addActivityDialogIsOpen}
            toggle={() => this.toggleModal()}
          >
            <ModalHeader toggle={() => this.toggleModal()}>
              Adicionar atividade
            </ModalHeader>
            <ModalBody>
              <FormGroup className="select2-container">
                <Label>Setor ou Projeto</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecionar..."
                  value={newActivity.project}
                  options={projects}
                  isDisabled={getProjectsIsLoading}
                  isLoading={getProjectsIsLoading}
                  onChange={option => {
                    console.log(option)
                    getActivities(option.value)
                    this.listProducts(option.proj_id)
                    this.setState({
                      newActivity: {
                        ...newActivity,
                        activity: '',
                        project: {
                          value: option.value,
                          label: option.label,
                          proj_id: option.proj_id,
                        },
                      },
                      projectInputError: '',
                    })
                  }}
                />
                {projectInputError && <span style={{ color: 'red' }}>{projectInputError}</span>}
              </FormGroup>
              <FormGroup className="select2-container">
                <Label>Atividade ou Produto</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecionar..."
                  value={{
                    label: newActivity.activity,
                    value: newActivity.activity,
                  }}
                  options={activities || []}
                  isDisabled={!newActivity.project || getActivitiesIsLoading}
                  isLoading={getActivitiesIsLoading}
                  onChange={option => {
                    this.setState({
                      newActivity: {
                        ...newActivity,
                        activity: option.value,
                      },
                      activityInputError: '',
                    })}
                  }
                />
                {activityInputError && <span style={{ color: 'red' }}>{activityInputError}</span>}
              </FormGroup>
              <FormGroup>
                <Label>Descrição</Label>
                <Input
                  className="form-control"
                  type="text"
                  autoCapitalize="sentences"
                  maxLength={500}
                  value={newActivity.description}
                  onChange={e => this.setState({
                    newActivity: {
                      ...newActivity,
                      description: e.target.value,
                    },
                    descriptionInputError: '',
                  })}
                />
                {descriptionInputError && <span style={{ color: 'red' }}>{descriptionInputError}</span>}
              </FormGroup>
              <FormGroup>
                <Label>Tempo dedicado (hh:mm)</Label>
                <Input
                  className="form-control"
                  type="text"
                  value={newActivity.time}
                  maxLength={5}
                  onChange={e => this.setState({
                    newActivity: {
                      ...newActivity,
                      time: e.target.value,
                    },
                    timeInputError: '',
                  })}
                />
                {timeInputError && <span style={{ color: 'red' }}>{timeInputError}</span>}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.toggleModal()}
                color="light"
                className="waves-effect"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => this.handleNewActivitySubmit(remainingTime())}
              >
                Adicionar
              </Button>
            </ModalFooter>
          </Modal>
          <Container fluid>
            <Breadcrumbs
              title={`${this.props.location.props.retroativo ? 'Registrar ponto retroativo' : 'Encerrar expediente'}`}
              breadcrumbItems={[{
                title: this.props.location.props.fullDate ? this.props.location.props.fullDate.toLowerCase() : (moment().format('dddd, DD [de] MMMM [de] YYYY')).toLowerCase(),
              }]}
            />
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Entrada</p>
                        <h5 className="mb-0">{this.props.location.props.DataEntrada || lastExpedientInput}</h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Saída</p>
                        <h5 className="mb-0">{exitTimeParsed}</h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Tempo total</p>
                        <h5 className="mb-0">{totalTime}</h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="my-3 d-flex align-items-end">
              <Col>
                <h4>
                  Atividades realizadas
                </h4>
              </Col>
              <Col style={{ textAlign: 'right' }}>
                {remainingTime() !== '00:00' && (
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => {
                      this.listProducts();
                      console.log(projects)
                      this.setState({
                        addActivityDialogIsOpen: true,
                        newActivity: {
                          ...newActivity,
                          time: remainingTime().toString(),
                        },
                      })
                    }}
                  >
                    Adicionar atividade
                  </Button>
                )}
                {
                  registeredActivities
                  && registeredActivities.length > 0
                  && remainingTime() === '00:00'
                  && (
                    <Button
                      color="primary"
                      type="button"
                      className="ml-2"
                      onClick={() => this.handleSubmit({
                        exitDate,
                        exitTime: exitTimeParsed,
                        inputTime: this.props.location.props.DataEntrada || lastExpedientInput,
                        retroativo: this.props.location.props.retroativo,
                        justificativa: this.props.location.props.justificativa,
                      })}
                      disabled={finishExpedientIsLoading}
                    >
                      Enviar
                    </Button>
                  )
                }
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="p-0">
                  {registeredActivities && registeredActivities.length > 0 ? (
                    <Table responsive striped bordered style={{ marginBottom: 0 }}>
                      <thead>
                        <tr>
                          <th data-priority="3">Setor ou Projeto</th>
                          <th data-priority="2">Atividade ou Produto</th>
                          <th data-priority="1">Descrição</th>
                          <th data-priority="4">Tempo dedicado (hh:mm)</th>
                          <th data-priority="5">Excluir</th>
                        </tr>
                      </thead>
                      <tbody>
                        {registeredActivities.map(activity => (
                          <tr>
                            <td>{activity.project.label}</td>
                            <td>{activity.activity}</td>
                            <td>{activity.description}</td>
                            <td>{activity.time}</td>
                            <td>
                              <Button
                                color="light"
                                size="sm"
                                type="button"
                                onClick={() => {
                                  const newArray = registeredActivities.filter(item => (
                                    item !== activity
                                  ))
                                  this.setState({ registeredActivities: newArray })
                                }}
                              >
                                <i className="ri-delete-bin-6-line font-size-16" />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <p className="text-center mb-0 p-3">Adicione ao menos uma atividade realizada neste expediente.</p>
                  )}
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <span>
                  Tempo restante:
                  {' '}
                  {remainingTime()}
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  humanResources: state.humanResources,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getLastExpedientInput,
  getProjects,
  getActivities,
  finishExpedient,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(FinishExpedient)

const DEFAULT_NEW_ACTIVITY = {
  project: '',
  activity: '',
  description: '',
  time: '',
}

const HOUR_MINUTE_REGEX = new RegExp('^([01]?[0-9]|2[0-3]):[0-5][0-9]$')
